export default "__VITE_ASSET__77a5102d__"